/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh

import japgolly.scalajs.react._
import japgolly.scalajs.react.extra.router._
import net.scalytica.blaargh.components._
import net.scalytica.blaargh.models.{Article, Config}
import net.scalytica.blaargh.pages.Views._
import net.scalytica.blaargh.pages._
import net.scalytica.blaargh.styles.CSSRegistry
import org.scalajs.dom

import scala.scalajs.js.annotation.{JSExport, JSExportTopLevel}
import scala.scalajs.concurrent.JSExecutionContext.Implicits.queue

object App {

  val slash = "[^\\/]*"
  val all   = "(.*)$"

  val SiteConfig = Config.load()

  val postsRule = RouterConfigDsl[ArticleRef].buildRule { dsl =>
    import dsl._

    dynamicRouteCT((string(slash) / string(all)).caseClass[ArticleRef]) ~>
      dynRenderR { (ref, ctl) =>
        ArticleView(
          article = Article.Articles.map(_.find(_.filename == ref.filename)),
          ref = ref,
          ctl = ctl
        )
      }
  }

  // All these rules are for handling the page navigation on the HomePage.
  val homeRules = RouterConfigDsl[View].buildRule { dsl =>
    import dsl._
    (
      // scalastyle:off
      // @formatter:off
      staticRoute(Home.basePath, Home) ~> renderR(ctl => HomePage(SiteConfig, ctl))
        | staticRoute(Gallery.basePath, Gallery) ~> renderR(ctl => HomePage(SiteConfig, ctl))
        | staticRoute(Publications.basePath, Publications) ~> renderR(ctl => HomePage(SiteConfig, ctl))
        | staticRoute(About.basePath, About) ~> renderR(ctl => HomePage(SiteConfig, ctl))
      // @formatter:on
      // scalastyle:on
    )
  }

  val routerConfig = RouterConfigDsl[View].buildConfig { dsl =>
    import dsl._

    (removeQuery
      | trimSlashes
      | homeRules
      | staticRoute(NotFound.basePath, NotFound) ~> render(NotFoundPage())
      | postsRule.prefixPath_/(Posts.basePath).pmap[View](Posts.apply) {
        case Posts(ref) => ref
      })
      .notFound(_ => redirectToPage(Home)(SetRouteVia.HistoryReplace))
      .onPostRender { (_: Option[View], view: View) =>
        view match {
          case v: View with ViewType =>
            Option(dom.document.getElementById(v.basePath_NoPrefix)).map { e =>
              Callback(e.scrollIntoView())
            }.getOrElse(Callback.empty)

          case _ => Callback.empty
        }
      }
      .renderWith((ctl, r) => layout(ctl, r))
  }

  val baseUrl = BaseUrl.until_#
  val router  = Router(baseUrl, routerConfig) //.logToConsole)

  def layout(ctl: RouterCtl[View], r: Resolution[View]) = {
    PageLayout(SiteConfig, ctl, r)
  }

  @JSExportTopLevel("App")
  protected def getInstance(): this.type = this

  @JSExport
  def main(): Unit = {
    CSSRegistry.load()
    router().renderIntoDOM(org.scalajs.dom.document.getElementById("app"))
  }

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/App.scala